import api from './api';

// 黑名单类型
export type BlacklistType = 'fingerprint' | 'ip';

// 黑名单状态
export type BlacklistStatus = 'active' | 'expired' | 'removed';

// 黑名单记录
export interface BlacklistEntry {
  id: number;
  client_id: number;
  blacklist_type: BlacklistType;
  identifier: string;
  reason: string;
  access_count: number;
  blocked_at: string;
  expires_at: string | null;
  created_by: number | null;
  status: BlacklistStatus;
  remark: string;
  created_at: string;
  updated_at: string;
}

// 黑名单配置
export interface BlacklistConfig {
  id: number;
  client_id: number;
  blacklist_type: BlacklistType;
  window_minutes: number;
  threshold: number;
  block_duration: number;
  enabled: boolean;
  created_at: string;
  updated_at: string;
}

// 列表请求参数
export interface ListEntriesRequest {
  client_id?: number;
  type?: BlacklistType;
  status?: BlacklistStatus;
  identifier?: string;
  page?: number;
  page_size?: number;
}

// 列表响应
export interface ListEntriesResponse {
  success: boolean;
  data: {
    list: BlacklistEntry[];
    total: number;
    page: number;
    page_size: number;
  };
}

// 添加黑名单请求
export interface AddEntryRequest {
  client_id?: number;
  blacklist_type: BlacklistType;
  identifier: string;
  remark?: string;
}

// 更新配置请求
export interface UpdateConfigRequest {
  client_id?: number;
  blacklist_type: BlacklistType;
  window_minutes: number;
  threshold: number;
  block_duration: number;
  enabled: boolean;
}

// 黑名单服务
export const blacklistService = {
  // 获取黑名单列表
  async listEntries(params: ListEntriesRequest): Promise<ListEntriesResponse> {
    const response = await api.post('/api/blacklist/entries', params);
    return response.data;
  },

  // 添加黑名单
  async addEntry(data: AddEntryRequest): Promise<{ success: boolean; message: string }> {
    const response = await api.post('/api/blacklist/add', data);
    return response.data;
  },

  // 移除黑名单
  async removeEntry(id: number): Promise<{ success: boolean; message: string }> {
    const response = await api.post('/api/blacklist/remove', { id });
    return response.data;
  },

  // 获取配置
  async getConfig(clientId?: number): Promise<{ success: boolean; data: BlacklistConfig[] }> {
    const response = await api.post('/api/blacklist/config', { client_id: clientId });
    return response.data;
  },

  // 更新配置
  async updateConfig(data: UpdateConfigRequest): Promise<{ success: boolean; message: string; data: BlacklistConfig }> {
    const response = await api.post('/api/blacklist/config/update', data);
    return response.data;
  },

  // 检查是否在黑名单中
  async checkBlocked(clientId: number, blacklistType: BlacklistType, identifier: string): Promise<{ success: boolean; data: { blocked: boolean } }> {
    const response = await api.post('/api/blacklist/check', {
      client_id: clientId,
      blacklist_type: blacklistType,
      identifier,
    });
    return response.data;
  },
};

export default blacklistService;
